module.exports = __webpack_public_path__ + "static/media/about_us.6f782a75.png";